import { zodResolver } from '@hookform/resolvers/zod';
import { type Sector, type UpdateSectorInput, updateSectorInputSchema } from '@idpe/schema';
import { createFileRoute } from '@tanstack/react-router';

import { Spinner } from '~/components/ui/Spinner.js';
import { TaxonomyCard } from '~/features/taxonomies/TaxonomyCard.js';
import { useSectorsList, useUpdateSector } from '~/features/taxonomies/hooks.js';

const sectorResolver = zodResolver(updateSectorInputSchema);

export const Route = createFileRoute('/_auth/sectors')({
  component: SectorsPage,
});

function SectorsPage() {
  const { data, isLoading, error, refetch } = useSectorsList();

  return (
    <div className="page">
      <header className="page-head">
        <p className="eyebrow">/ O site</p>
        <h1 className="page-title">Setores</h1>
        <p className="page-sub">
          As frentes de atuação do IDPE, usadas para classificar os projetos. A cor escolhida aqui é
          a mesma que marca o setor nos cards de soluções e nos pinos do mapa.
        </p>
      </header>

      {isLoading && (
        <div className="dt__state">
          <Spinner size="lg" />
        </div>
      )}

      {error && (
        <div className="dt__state">
          <p className="dt__state-title">Não foi possível carregar.</p>
          <p className="dt__state-sub">{error.displayMessage}</p>
          <button type="button" onClick={() => void refetch()} className="btn btn--secondary">
            Tentar novamente
          </button>
        </div>
      )}

      {data && (
        <section className="taxonomy-stack">
          {data.map((sec) => (
            <SectorCard key={sec.slug} sector={sec} />
          ))}
        </section>
      )}
    </div>
  );
}

function SectorCard({ sector }: { sector: Sector }) {
  const update = useUpdateSector(sector.slug);

  const defaults: UpdateSectorInput = {
    nome: sector.nome,
    descricao: sector.descricao ?? '',
    cor: sector.cor,
    ordem: sector.ordem,
    visivel: sector.visivel,
  };

  return (
    <TaxonomyCard<Sector, UpdateSectorInput>
      item={sector}
      resolver={sectorResolver as never}
      defaults={defaults}
      onSave={(values) => update.mutateAsync(values)}
      isPending={update.isPending}
    />
  );
}
